import React from 'react'
import {AuthProvider} from "./context";
import {BrowserRouter} from 'react-router-dom'
import {ConfigProvider} from 'antd'
import {IntlProvider} from 'react-intl'
import AppLocale from './lngProvider'
import "antd/dist/antd.css"
import './stylesheet/styles.css'
import './stylesheet/antd.css'
import './stylesheet/customize.css'
import {AppContainer} from "./pages/container/AppContainer";

function App() {
  let currentAppLocale = AppLocale['ja']
  return (
    currentAppLocale &&
    <ConfigProvider locale={currentAppLocale.antd}>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}>
        <AuthProvider>
          <BrowserRouter>
            <AppContainer/>
          </BrowserRouter>
        </AuthProvider>
      </IntlProvider>
    </ConfigProvider>
  )
}

export default App
